export const SSO_CTA_URL = "SSO_CTA_URL";
export const SSO_ERROR_URL = "SSO_ERROR_URL";
export const SSO_NEXT_PATH = "SSO_NEXT_PATH";
